export default __webpack_public_path__ + "static/banner2-6311118467469abd337a975c515648c6.jpg";